import Inventory from "@material-symbols/svg-500/rounded/inventory.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const InventoryIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Inventory });
	return <Icon />;
};

export default memo(InventoryIcon);
